// extracted by mini-css-extract-plugin
export var projectImg = "project-module--projectImg--DlaPg";
export var projectImg__single = "project-module--projectImg__single--4Lrru";
export var projectImg__open = "project-module--projectImg__open--O8UCP";
export var projectInfo = "project-module--projectInfo--pU1W0";
export var project = "project-module--project--zpxiJ";
export var projectThumb = "project-module--projectThumb--tG5zd";
export var sliderWrapper = "project-module--sliderWrapper--o7pyo";
export var Modal = "project-module--Modal--2jFow";
export var modalClose = "project-module--modalClose--dWqNr";